import React from 'react';

function Messages(props: object) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.04698 12.9374C2.28297 11.5101 2.0574 9.85572 2.41141 8.27596C2.76542 6.6962 3.67542 5.29629 4.97548 4.3315C6.27554 3.36672 7.87905 2.90132 9.49362 3.02018C11.1082 3.13904 12.6263 3.83423 13.771 4.97899C14.9158 6.12375 15.611 7.64183 15.7298 9.2564C15.8487 10.871 15.3833 12.4745 14.4185 13.7745C13.4537 15.0746 12.0538 15.9846 10.4741 16.3386C8.8943 16.6926 7.23993 16.4671 5.8126 15.703L3.2101 16.468C3.08087 16.506 2.94381 16.5084 2.81331 16.4751C2.68281 16.4418 2.56368 16.374 2.46845 16.2788C2.37321 16.1835 2.30538 16.0644 2.27207 15.9339C2.23876 15.8034 2.24121 15.6663 2.27916 15.5371L3.04698 12.9374Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3696 7.51074C16.5035 7.57239 17.6036 7.91912 18.5679 8.51884C19.5322 9.11856 20.3297 9.95188 20.8864 10.9417C21.4431 11.9314 21.7411 13.0457 21.7528 14.1812C21.7645 15.3167 21.4896 16.4369 20.9534 17.4379L21.7184 20.0404C21.7563 20.1697 21.7588 20.3067 21.7255 20.4372C21.6921 20.5677 21.6243 20.6868 21.5291 20.7821C21.4338 20.8773 21.3147 20.9452 21.1842 20.9785C21.0537 21.0118 20.9166 21.0093 20.7874 20.9714L18.1877 20.2036C17.329 20.6628 16.3811 20.931 15.409 20.9896C14.4369 21.0482 13.4636 20.896 12.5559 20.5433C11.6481 20.1905 10.8274 19.6457 10.1499 18.9461C9.47243 18.2465 8.95424 17.4087 8.63086 16.4901"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Messages;
